module.exports = __webpack_public_path__ + "img/bac_05.41c62c36.png";